const trackerName = 'sp'

const Snowplow = {
  trackerName,
  domainUserIdCookie: `lux_${trackerName}_domain_user_id`,
  sessionIdCookie: `lux_${trackerName}_session_id`,
  sessionIdxCookie: `lux_${trackerName}_session_idx`,
  postPath: '/com.luxgroup/tp2',
}
export default Snowplow
